import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";
import React from "react";
import LpContractAndCivilLawLVMMeta from "./LVM/LpContractAndCivilLawLVMMeta.tsx";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes.tsx";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser.tsx";
import LinkedCardBox from "@/src/components/LinkedCardBox/LinkedCardBox.tsx";
import { defaultProvenExpertTeaserCard } from "@/src/services/landingPageService";
import iconAttorneys from "@/src/assets/icons/generic/IconLawyers.tsx";
import iconDocument from "@/src/assets/icons/generic/IconDocument.tsx";
import PartnerLogoSection from "@/src/components/Sections/Generic/PartnerLogoSection/PartnerLogoSection.tsx";
import Container from "@/src/components/Container/Container.tsx";
import HowItWorksSectionConsulting from "@/src/components/Sections/FamilyLaw/Consulting/HowItWorksSection/HowItWorksSectionConsulting.tsx";
import AttorneySection from "@/src/components/Sections/Generic/AttorneySection/AttorneySection.tsx";
import ContractAndCivilLawConsultingCheckin from "@/src/components/Checkin/MixedCheckin/Consulting/ContractAndCivilLawConsultingCheckin.tsx";

const getMetaDataByPartner = ({ partner }: { partner: string }) => {
  switch (partner) {
    case PARTNER_IRIS.LVM:
      return <LpContractAndCivilLawLVMMeta />;
    default:
      return null;
  }
};

const LpContractAndCivilLawPartner = ({ partner }: { partner: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  const { isLoggedIn } = useCustomer();
  const metaData = getMetaDataByPartner({ partner });

  return (
    <LayoutPublicRoutes minimal={!isLoggedIn} clickableLogo={isLoggedIn}>
      {metaData}
      <LandingPageTeaser
        teaserButtonText={"Jetzt starten"}
        headline={"Professionelle Hilfe im Vertrags- und Zivilrecht "}
        subheadline={"Kurz Anliegen schildern und Gespräch vereinbaren"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox
          linkedCards={[
            defaultProvenExpertTeaserCard,
            {
              icon: iconAttorneys,
              heading: "Professionelle Beratung",
            },
            {
              icon: iconDocument,
              heading: "Unkomplizierte Abwicklung",
            },
          ]}
        />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={partner} containerStyle={"settlementContainer"} />
      {!isLoggedIn && (
        <Container>
          <ContractAndCivilLawConsultingCheckin idPrefix={"top"} partner={partner} />
        </Container>
      )}
      <HowItWorksSectionConsulting />
      <AttorneySection
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <ContractAndCivilLawConsultingCheckin idPrefix={"top"} partner={partner} />
        </Container>
      )}
    </LayoutPublicRoutes>
  );
};

export default LpContractAndCivilLawPartner;
